import React, { useState, useEffect } from "react";
import CustomStepper2 from "../BuisnessDashboard/common/CustomStepper2";
import BarChartsMain from "../BuisnessDashboard/common/BarChartsSTackedMain";
import FunnelChart2 from "../BuisnessDashboard/common/FunnelChart2";
import CustomDateFilter from "../BuisnessDashboard/common/CustomDateFilter";
import AggregatorDetailsMain from "./Aggregators/AggregatorDetails/Main";
import Loader from "../../../presentationals/Loader/Loader.component";
import moment from "moment";
import { InitalDateFn } from "../../../../utils/commonUtility";
import {
  getMArketingPerformanceStatsByDate,
  getMArketingPerformanceStatsByDateNew,
  getAllApplicationStatsByDate,
  getAggregatedcountByFormStatusByBucketType,
  getAggregatorDetailsByDateFilter,
  getLeakageAnalysisDetailsByDateFilter,
} from "./ActionCreator";
import {
  getAggregatorLoanStatsByDate,
  getAggregatorLoanStatsByDateNew,
  getAggregatorEventsByMonth,
} from "../maketingComponents/actioncreator";
import { ChevronLeft } from "lucide-react";
import DateFilterSelect from "../../../CustomDatePicker/DateFilterSelectold";
import { CASHBRIDGE_LIKE, CHECK_COMPANY_TENANT } from "../../../../layouts/MainTenantconfig";

const customMarginTop = window.innerWidth > 1800 ? "60px" : "30px";

export default function Dashboard({ handleBack, handleFilter, commonFilter }) {
  const [viewType, setViewType] = useState("dashboard");
  const [infoData, setInfoData] = useState({});
  const [loader, setLoader] = useState(false);
  const [dateFilterPopup, setDateFilterPopup] = useState({ show: false, from: moment().subtract(6, 'days').format("YYYY-MM-DD"), to: moment(new Date).format("YYYY-MM-DD") })

  const [tableData, settableData] = useState([]);
  const [BarchartFilter, setBarchartFilter] = useState({
    type: "monthly",
    apiType: "",
    apiList: [],
  });
  const [statsOption, setStatsOption] = useState({});
  const [StepperData, setStepperData] = useState([]);
  const [barcahrtData, setBarchartData] = useState([]);
  const [leakageAnalysis, setLeakageAnalysis] = useState([]);
  const [funnelData, setFunnelData] = useState([]);
  const [isFilterCleared, setIsFilterCleared] = useState(false);


  useEffect(() => {
    if (
      commonFilter?.fromDate !== dateFilterPopup.from ||
      commonFilter?.toDate !== dateFilterPopup.to
    ) {
      setDateFilterPopup((prev) => ({
        ...prev,
        from: commonFilter.fromDate,
        to: commonFilter.toDate
      }));
    }
    const obj = { from: commonFilter.fromDate, to: commonFilter.toDate }
    MainApi(obj);
  }, [commonFilter]);

  const handleTab = (type, data) => {
    setInfoData(data);
    setTimeout(() => {
      setViewType(type);
    }, 200);
  };

  const handleDateFilterPopup = (type, val) => {
    setDateFilterPopup((prev) => ({ ...prev, [type]: val }));

    const formatted = moment(val).format("YYYY-MM-DD");

    setDateFilterPopup((prev) => {
      if (prev[type] === formatted) return prev; // prevent useless update

      return {
        ...prev,
        [type]: formatted
      };
    });

    if (type === "from") {
      if (commonFilter.fromDate !== formatted) {
        handleFilter("fromDate", formatted);
      }
    } else {
      if (commonFilter.toDate !== formatted) {
        handleFilter("toDate", formatted);
      }
    }
  };

  const handleApplyDteFilter = () => {
    handleDateFilterPopup("show", false);
    MainApi();
  };
  const handleResetFilter = () => {
    const today = moment(new Date).format("YYYY-MM-DD");
    setIsFilterCleared(true);
    setDateFilterPopup({
      show: false,
      from: today,
      to: today,
    });

    setTimeout(() => {
      MainApi({ from: today, to: today });
      setIsFilterCleared(false);
    }, 200);
  };

  useEffect(() => {
    if (BarchartFilter?.type) {
      StatsApi(dateFilterPopup)
      // GraphData(dateFilterPopup);
    }
  }, [BarchartFilter.type]);

  // useEffect(() => {
  //   MainApi(dateFilterPopup);
  // }, [dateFilterPopup?.from, dateFilterPopup?.to]);

  const MainApi = (customDate) => {
    StatsApi(customDate);
    StepperApi(customDate);
    GraphData(customDate);
    AggregatorListData(customDate);
    LeakageAnalysis(customDate);
    funnelFn(customDate);
  };

  const StatsApi = (customDate) => {
    const sDate = moment(customDate?.from).format("DD-MM-YYYY");
    const eDate = moment(customDate?.to).format("DD-MM-YYYY");
    setLoader(true);
    // getMArketingPerformanceStatsByDate(sDate, eDate, (callback) => {
    getMArketingPerformanceStatsByDateNew(sDate, eDate, BarchartFilter?.type, (callback) => {
      setLoader(false);
      setBarchartData(callback?.data ?? []);

    });
  };

  const StepperApi = (customDate) => {
    const sDate = moment(customDate?.from).format("DD-MM-YYYY");
    const eDate = moment(customDate?.to).format("DD-MM-YYYY");
    setLoader(true);
    getAllApplicationStatsByDate(sDate, eDate, (callback) => {
      const statusCountMap = callback?.statusList?.reduce((acc, item) => {
        acc[item.status] = item.count;
        return acc;
      }, {});

      getAggregatedcountByFormStatusByBucketType(
        sDate,
        eDate,
        "",
        (response) => {
          setLoader(false);
          const hoverDataMap = response?.data || {};

          const getHoverData = (status) => ({
            Mail: hoverDataMap?.[status]?.mail ?? 0,
            SMS: hoverDataMap?.[status]?.sms ?? 0,
            Call: hoverDataMap?.[status]?.call ?? 0,
          });

          setStepperData([
            {
              name: "Basic",
              value: statusCountMap["Basic"] ?? 0,
              hoverData: getHoverData("Basic"),
            },
            {
              name: "KYC Verification",
              value: statusCountMap["KYC Verification"] ?? 0,
              hoverData: getHoverData("KYC Verification"),
            },
            {
              name: "Account Details",
              value: statusCountMap["Account Details"] ?? 0,
              hoverData: getHoverData("Account Details"),
            },
            {
              name: "Employment Details",
              value: statusCountMap["Employment Details"] ?? 0,
              hoverData: getHoverData("Employment Details"),
            },
            {
              name: "Documents",
              value: statusCountMap["Documents"] ?? 0,
              hoverData: getHoverData("Documents"),
            },
            {
              name: "Selfie",
              value: statusCountMap["Selfie"] ?? 0,
              hoverData: getHoverData("Selfie"),
            },
            {
              name: "Loan Details",
              value: statusCountMap["Loan Details"] ?? 0,
              hoverData: getHoverData("Loan Details"),
            },
            {
              name: "Reference",
              value: statusCountMap["Reference"] ?? 0,
              hoverData: getHoverData("Reference"),
            },
            {
              name: "Complete",
              value: statusCountMap["Thanks"] ?? 0,
              hoverData: getHoverData("Thanks"),
            },
          ]);
        },
      );
    });
  };

  const GraphData = (customDate) => {
    const sDate = moment(customDate?.from).format("DD-MM-YYYY");
    const eDate = moment(customDate?.to).format("DD-MM-YYYY");
    setLoader(true);
    // getAggregatorLoanStatsByDate(
    getAggregatorLoanStatsByDateNew(
      sDate,
      eDate,

      (callback) => {
        setLoader(false);
        // setBarchartData(callback?.data ?? []);
        setStatsOption({
          "New User": callback?.data?.[0]?.totalUsers ?? "0",
          Applications: callback?.data?.[0]?.totalApplications ?? "0",
          "Rejected Applications": callback?.data?.[0]?.totalRejected ?? "0",
          "Disbursed Applications":
            callback?.data?.[0]?.totalDisbursed ?? "0",
          "Total Disbursement Amount":
            callback?.data?.[0]?.disbursementAmount ?? "0",
          // "Budgeted Disbursement Amount":
          //   callback?.data?.[0]?.budgetedDisbursementAmt ?? "0",
          // "Cost per Lead (CPL)": callback?.data?.[0]?.cpl ?? "0",
          // "Cost per Disbursal (CPD)": callback?.data?.[0]?.cpd ?? "0",
          "Revenue Generated (₹)": callback?.data?.[0]?.totalRevenue ?? "0",
          "Lead → Application %": callback?.data?.[0]?.leadApplicationRate ?? "0",
          "Application → Approval %":
            callback?.data?.[0]?.applicationApprovalRate ?? "0",
          "Approval → Disbursal %":
            callback?.data?.[0]?.approvalDisbursementRate ?? "0",
          "Overall Lead → Disbursal %":
            callback?.data?.[0]?.leadDisbursementRate ?? "0",
          // "Marketing ROI (%)": callback?.data?.[0]?.rateOnInvestment ?? "0",
        });
      },
    );
  };
  const AggregatorListData = (customDate) => {
    const sDate = moment(customDate?.from).format("DD-MM-YYYY");
    const eDate = moment(customDate?.to).format("DD-MM-YYYY");
    setLoader(true);
    getAggregatorDetailsByDateFilter(sDate, eDate, "", (callback) => {
      setLoader(false);
      settableData(callback?.data ?? []);
    });
  };
  const LeakageAnalysis = (customDate) => {
    const sDate = moment(customDate?.from).format("DD-MM-YYYY");
    const eDate = moment(customDate?.to).format("DD-MM-YYYY");
    setLoader(true);
    getLeakageAnalysisDetailsByDateFilter(sDate, eDate, (callback) => {
      setLoader(false);
      setLeakageAnalysis(callback?.data?.[0] ?? []);
    });
  };
  const funnelFn = (customDate) => {
    const sDate = moment(customDate?.from).format("DD-MM-YYYY");
    const eDate = moment(customDate?.to).format("DD-MM-YYYY");
    setLoader(true);
    getAggregatorEventsByMonth(sDate, eDate, (callback) => {
      setLoader(false);
      const eventsMap = (callback?.data?.events || []).reduce((acc, item) => {
        acc[item.event] = item;
        return acc;
      }, {});

      setFunnelData([
        {
          name: "Lead → App Open Rate",
          value: eventsMap["LOGIN_MOBILE"]?.count ?? "",
        },
        {
          name: "App Open → KYC Started %",
          value: eventsMap["AADHAAR_KYC_SUCCESS"]?.count ?? "",
        },
        {
          name: "KYC Completion Rate",
          value: eventsMap["PAN_KYC_SUCCESS"]?.count ?? "",
        },
        {
          name: "Bank Statement Upload Rate",
          value: eventsMap["DOCUMENTS_ADDED_SUCCESSFULLY"]?.count ?? "",
        },
        {
          name: "Selfie Completion Rate",
          value: eventsMap["SELFIE_ADDED_SUCCESSFULLY"]?.count ?? "",
        },
        {
          name: "Application Completion Rate",
          value: eventsMap["LOAN_FORM_COMPLETED"]?.count ?? "",
        },
        // { name: "Drop-off Stage Analysis", value: 3329 },
      ]);
    });
  };

  const handleCustomDetails = (id) => {
    const obj = {
      start: moment(dateFilterPopup?.from).format("DD-MM-YYYY"),
      end: moment(dateFilterPopup?.to).format("DD-MM-YYYY"),
      id: id?.aggregatorId,
      name: id?.aggregatorName,
    };

    handleTab("details", obj);
  };

  return (
    <>
      {loader ? <Loader /> : ""}
      {viewType == "dashboard" ? (
        <div
          className="OverView-Main-Section min-size-marketing-1800"
          style={{ background: "rgb(250, 250, 250)" }}
        >
          <div className="HeadingFilter-Section">
            <div>
              <h4
                onClick={(e) => handleBack(e)}
                style={{
                  margin: 0,
                  display: "flex",
                  gap: "5px",
                  alignItems: "center",
                  whiteSpace: "nowrap",
                  cursor: "pointer",
                }}
              >
                {" "}
                <ChevronLeft />
                Overall Performance Summary
              </h4>
            </div>
            <div className="topsTabs" style={{ border: "none" }}>
              <div className="rightTabs" style={{ padding: "0" }}>
                <button
                  className={`rightSideBtn active`}
                  style={{ background: "#035865", color: "#fff" }}
                >
                  Export
                </button>
              </div>
            </div>
          </div>

          {/* {!CHECK_COMPANY_TENANT(CASHBRIDGE_LIKE) ? */}
            <div className="statsOption" style={{ marginTop: "30px" }}>
              <div className="cusombox">
                {Object.keys(statsOption)?.length > 0
                  ? Object.entries(statsOption)?.map(([key, val], id) => {
                    if (id > 4) return;
                    return (
                      <div
                        style={{
                          borderRight:
                            id + 1 == 5
                              ? "none"
                              : "1px solid rgba(0, 0, 0, 0.12)",
                          padding: "5px 10px",
                          width: `calc(100% / 5)`,
                        }}
                      >
                        <h5>{val}</h5>
                        <h6>{key}</h6>
                      </div>
                    );
                  })
                  : ""}
              </div>

              <hr style={{ margin: "1.5% 8%" }} />

              <div className="cusombox">
                {Object.keys(statsOption)?.length > 0
                  ? Object.entries(statsOption)?.map(([key, val], id) => {
                    if (id <= 4) return;
                    return (
                      <div
                        style={{
                          borderRight:
                            id + 1 == Object.keys(statsOption)?.length
                              ? "none"
                              : "1px solid rgba(0, 0, 0, 0.12)",
                          padding: "5px 10px",
                          width: `calc(100% / 5)`,
                        }}
                      >
                        <h5>{val}</h5>
                        <h6>{key}</h6>
                      </div>
                    );
                  })
                  : ""}
              </div>
            </div>
            {/* : ""} */}

          <div style={{ margin: window.innerWidth > 1800 ? "0 4%" : "" }}>
            <div
              className="HeadingFilter-main-filters"
              style={{ marginTop: customMarginTop }}
            >
              <div className="row">
                <div
                  className="col-xl-9 col-md-9 col-xs-12"
                  style={{ display: "flex", gap: "10px", marginTop: "5px" }}
                >
                  {/* <div className='custom-popup' style={{ width: '40%' }}>
                                            <div className='customSelectBox ' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '20px', cursor: 'pointer' }} onClick={() => handleDateFilterPopup("show", !dateFilterPopup?.show)}>
                                                <div style={{ display: 'flex', gap: '7px', alignItems: 'center' }}>
                                                    <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M6 0.75V2.25M3 0.75V2.25" stroke="#0C0B10" stroke-width="0.5625" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M4.875 1.5H4.125C2.71079 1.5 2.00368 1.5 1.56434 1.93934C1.125 2.37868 1.125 3.08579 1.125 4.5V5.25C1.125 6.6642 1.125 7.37134 1.56434 7.81065C2.00368 8.25 2.71079 8.25 4.125 8.25H4.875C6.2892 8.25 6.99634 8.25 7.43565 7.81065C7.875 7.37134 7.875 6.6642 7.875 5.25V4.5C7.875 3.08579 7.875 2.37868 7.43565 1.93934C6.99634 1.5 6.2892 1.5 4.875 1.5Z" stroke="#0C0B10" stroke-width="0.5625" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M1.125 3.75H7.875" stroke="#0C0B10" stroke-width="0.5625" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>

                                                    {
                                                        dateFilterPopup?.from && dateFilterPopup?.to
                                                            ? `${moment(dateFilterPopup?.from).format("DD MMM YYYY")} - ${moment(dateFilterPopup?.to).format("DD MMM YYYY")}`
                                                            : "Select Date Range"
                                                    }
                                                </div>
                                                <div style={{ marginTop: '-5px' }}>
                                                    <svg width="8" height="4" viewBox="0 0 8 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M7.375 0.375025C7.375 0.375025 4.79731 3.375 3.875 3.375C2.95263 3.375 0.375 0.375 0.375 0.375" stroke="#686C70" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                </div>
                                            </div>
                                            {
                                                dateFilterPopup?.show ?
                                                    <CustomDateFilter
                                                        payload={dateFilterPopup}
                                                        handlechange={handleDateFilterPopup}
                                                        handleApply={handleApplyDteFilter}
                                                    />
                                                    : ""}
                                        </div> */}
                  <DateFilterSelect
                    value={[new Date(commonFilter.fromDate), new Date(commonFilter.toDate)]}
                    onChange={(range) => {
                      handleDateFilterPopup("from", range[0]);
                      handleDateFilterPopup("to", range[1]);
                    }}
                    isFilterCleared={isFilterCleared}
                  />
                </div>
                <div
                  className="col-xl-3 col-md-3 col-xs-12"
                  style={{ marginTop: "5px" }}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "8px",
                      justifyContent: window.innerWidth > 991 ? "end" : "start",
                    }}
                  >
                    {/* <div className='custom-btn'>
                                                    <i class="fa fa-filter" aria-hidden="true"></i>
                                                </div> */}
                    <div className="custom-btn">
                      <i
                        class="fa fa-times"
                        aria-hidden="true"
                        onClick={() => handleResetFilter()}
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style={{ marginTop: customMarginTop }}>
              <CustomStepper2 Data={StepperData} hoverShow={true} />
            </div>

            <div className="row" style={{ marginTop: customMarginTop }}>
              <div className="col-sm-6 col-xs-12">
                <FunnelChart2
                  heading={"Engagement & Drop-Off KPIs"}
                  Data={funnelData}
                />
              </div>
              <div className="col-sm-6 col-xs-12">
                <BarChartsMain
                  barcolor={"#9F86BD"}
                  xAxisDataKey={BarchartFilter?.type == "monthly" ? "monthName" : BarchartFilter?.type == "weekly" ? "weekName" : "date"}
                  barData={barcahrtData}
                  yAxisLabel={"freshDisbursedLeads"}
                  heading={"Leads Count Graph"}
                  chartFilterValues={BarchartFilter}
                  setFilters={setBarchartFilter}
                  heightcustom={window.innerWidth > 1800 ? "340px" : "252px"}
                  showFilters={true}
                  angelTilt={"-15"}
                  yAxisLabel2={"repeatDisbursedLeads"} barcolor2={"#045866"}
                />
              </div>
            </div>

            <div className="row" style={{ marginTop: customMarginTop }}>
              <div className="col-xs-12">
                <div className="customDash-table">
                  <div>
                    <h5>Aggregator</h5>
                  </div>
                  <div className="main-customized-table">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Info</th>
                          <th>Aggregator Name</th>
                          <th>Aggregator ID</th>
                          <th>Leads</th>
                          <th>Potential Leads</th>
                          {/* <th>Rule</th> */}
                          <th>Partners</th>
                          <th>Active Campaigns</th>
                          {/* <th>Events</th> */}
                          <th>CRM Mapping Key</th>
                          {/* <th>Commercial Model</th> */}
                          <th>Budget Utilization</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tableData?.length > 0
                          ? tableData?.map((val, id) => {
                            if (id + 1 == tableData?.length) return null;
                            return (
                              <tr key={id}>
                                <td>
                                  <div
                                    className="InfoIcon"
                                    onClick={() => handleCustomDetails(val)}
                                  >
                                    <h5>i</h5>
                                  </div>
                                </td>
                                <td>{val?.aggregatorName ?? ""}</td>
                                <td>{val?.aggregatorId ?? ""}</td>
                                <td>{val?.totalLeads ?? ""}</td>
                                <td>{val?.potentialLeads ?? ""}</td>
                                <td>{val?.partners ?? ""}</td>
                                <td>{val?.activeCampaigns ?? ""}</td>

                                <td>
                                  {val?.costModelType ? (
                                    <div
                                      style={{
                                        borderRadius: "6px",
                                        padding: "5px 10px",
                                        background: "#FFF5C7",
                                        color: "#A47E06",
                                        width: "fit-content",
                                        margin: "0 auto",
                                      }}
                                    >
                                      {val?.costModelType ?? ""}
                                    </div>
                                  ) : (
                                    "-"
                                  )}
                                </td>
                                <td>
                                  <div className="progressbar">
                                    <div className="progress">
                                      <div
                                        className="progress-width"
                                        style={{
                                          background: "#F49F28",
                                          width: val?.budgetUtilization + "%",
                                        }}
                                      ></div>
                                    </div>
                                    <h5>{val?.budgetUtilization ?? ""}%</h5>
                                  </div>
                                </td>

                                <td>
                                  {" "}
                                  <div
                                    style={{
                                      borderRadius: "6px",
                                      padding: "5px 10px",
                                      background: val?.status
                                        ? "#35A04F2B"
                                        : "#a035352b",
                                      color: val?.status
                                        ? "#327E45"
                                        : "#a93636",
                                      width: "fit-content",
                                      margin: "0 auto",
                                    }}
                                  >
                                    {val?.status ? "Active" : "Inactive"}
                                  </div>
                                </td>
                              </tr>
                            );
                          })
                          : ""}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="leakage-block Areachart-box"
              style={{ marginTop: customMarginTop }}
            >
              <div className="topHeader">
                <div>
                  <h5>Leakage Analysis</h5>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6 col-xs-12">
                  <div className="leftcard">
                    <h6>Top 3 Aggregators with Maximum Leakage</h6>

                    <div className="cardss" style={{ background: "#35A04F0D" }}>
                      <div>
                        <h5 style={{ color: "#327E45" }}>#1</h5>
                      </div>
                      <div>
                        <h4>
                          {leakageAnalysis?.top3Aggregators?.[0]
                            ?.aggregatorName ?? ""}
                        </h4>
                        <pre className="detailss">
                          Refused:
                          {leakageAnalysis?.top3Aggregators?.[0]?.refusedRate ??
                            ""}
                          %    Reject:
                          {leakageAnalysis?.top3Aggregators?.[0]
                            ?.rejectedRate ?? ""}
                          %   Total:
                          {leakageAnalysis?.top3Aggregators?.[0]?.totalLeads ??
                            ""}
                        </pre>
                      </div>
                    </div>
                    <div className="cardss" style={{ background: "#F49F280F" }}>
                      <div>
                        <h5 style={{ color: "#F49F28" }}>#2</h5>
                      </div>
                      <div>
                        <h4>
                          {leakageAnalysis?.top3Aggregators?.[1]
                            ?.aggregatorName ?? ""}
                        </h4>
                        <pre className="detailss">
                          Refused:
                          {leakageAnalysis?.top3Aggregators?.[1]?.refusedRate ??
                            ""}
                          %    Reject:
                          {leakageAnalysis?.top3Aggregators?.[1]
                            ?.rejectedRate ?? ""}
                          %   Total:
                          {leakageAnalysis?.top3Aggregators?.[1]?.totalLeads ??
                            ""}
                        </pre>
                      </div>
                    </div>
                    <div className="cardss" style={{ background: "#EB606217" }}>
                      <div>
                        <h5 style={{ color: "#EB6062" }}>#3</h5>
                      </div>
                      <div>
                        <h4>
                          {leakageAnalysis?.top3Aggregators?.[2]
                            ?.aggregatorName ?? ""}
                        </h4>
                        <pre className="detailss">
                          Refused:
                          {leakageAnalysis?.top3Aggregators?.[2]?.refusedRate ??
                            ""}
                          %    Reject:
                          {leakageAnalysis?.top3Aggregators?.[2]
                            ?.rejectedRate ?? ""}
                          %   Total:
                          {leakageAnalysis?.top3Aggregators?.[2]?.totalLeads ??
                            ""}
                        </pre>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-xs-12">
                  <div className="leftcard">
                    <h6>Overall Leakage Statistics</h6>
                    <div
                      className="cardss"
                      style={{
                        background: "#E979791C",
                        border: "0.5px solid #EB6062",
                      }}
                    >
                      <div>
                        <h4>Total Rejected Rate</h4>
                        <h3>
                          {leakageAnalysis?.overallLeakage?.totalRejectedRate ??
                            ""}
                          %
                        </h3>
                        {/* <pre className='detailss'>16.8% of total amount</pre> */}
                      </div>
                    </div>
                    <div
                      className="cardss"
                      style={{
                        background: "#F07F3326",
                        border: "0.5px solid #F07F33",
                      }}
                    >
                      <div>
                        <h4>Rejection From Credit</h4>
                        <h3>
                          {leakageAnalysis?.overallLeakage?.rejectFromCredit ??
                            ""}
                          %
                        </h3>
                        {/* <pre className='detailss'>15.3% of confirmed login amount</pre> */}
                      </div>
                    </div>
                    <div
                      className="cardss"
                      style={{
                        background: "#F4CB2821",
                        border: "0.5px solid #F4CB28",
                      }}
                    >
                      <div>
                        <h4>Rejection From LUP</h4>
                        <h3>
                          {leakageAnalysis?.overallLeakage?.rejectFromLUP ?? ""}
                          %
                        </h3>
                        {/* <pre className='detailss'>From lead to disbursement</pre> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}

      {viewType == "details" ? (
        <AggregatorDetailsMain handleBack={handleTab} Data={infoData} commonFilter={commonFilter} />
      ) : (
        ""
      )}
    </>
  );
}
